'use strict';

bbw.directive.bindNl2Br = function() {
    return {
        scope: {
            value: '=bindNl2br'
        },
        link: function(scope, element) {
            function update(input) {
                input = angular.isString(input) ? (input.replace(/&/g, "&amp;").
                    replace(/</g, "&lt;").
                    replace(/>/g, "&gt;").
                    replace(/"/g, "&quot;").
                    replace(/'/g, "&#039;").
                    replace(/\n/g, '<br>')) : '';
                element.html(input);
            }

            scope.$watch('value', update);
            update(scope.value);
        }
    }
};
